import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-squares-horizontal',
  templateUrl: './university-squares-horizontal-line.component.html',
  styleUrls: ['./university-squares-horizontal-line.component.scss']
})
export class UniversitySquaresHorizontalLineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
